import 'bootstrap/dist/css/bootstrap.min.css';
import React  from 'react';
import { Provider,useDispatch, useSelector } from "react-redux";
import thunkMiddleware from "redux-thunk";
import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { NotificationContainer } from "react-notifications";
import dynamic from 'next/dynamic';
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import "../styles/sass/main.scss";
import "react-notifications/lib/notifications.css";
import useIdleLogout from "../helpers/idleLogout";
import toggleLoading from "../store/reducers/loader";
import shop from "../store/reducers/shop";
import auth from "../store/reducers/auth";
import liveEvent from "../store/reducers/liveEvents";
import acceptPolicy from "../store/reducers/acceptPolicy";
import ComponentWrapper from "../components/hoc/ComponentsWrapper";
import Router from "next/router";
import { useEffect,useState } from "react";
import '../sentry.server.config';
import { useRouter } from "next/router";







// if (process.env.environment !== "dev") {
//   LogRocket.init("yuus11/kilimanjaro");
// }

const FreshChatWidget = dynamic(
  () => import('../components/FreshChatWidget'),
  { ssr: false }
);



const persistConfig = {
  key: "root",
  storage,
  blacklist: ["auth", "loader", "liveEvent", "acceptPolicy"],
};

const reducers = combineReducers({
  loader: toggleLoading,
  shop: persistReducer(persistConfig, shop),
  auth: auth,
  liveEvent: liveEvent,
  acceptPolicy: acceptPolicy,
});

const store =
  process.env.environment === "dev"
    ? createStore(
        reducers,
        composeWithDevTools(applyMiddleware(thunkMiddleware))
      )
    : createStore(reducers, applyMiddleware(thunkMiddleware));

persistStore(store);

function MyApp({ Component, pageProps }) {

  const GA_TRACKING_ID = "G-X1DLLVD29M"; 
const router = useRouter();


// useEffect(() => {
//   const loadAnalytics = () => {
//     // Load GA script
//     const script1 = document.createElement("script");
//     script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
//     script1.async = true;
//     document.head.appendChild(script1);

//     // Init GA config
//     const script2 = document.createElement("script");
//     script2.innerHTML = `
//       window.dataLayer = window.dataLayer || [];
//       function gtag(){dataLayer.push(arguments);}
//       gtag('js', new Date());
//       gtag('config', '${GA_TRACKING_ID}', { page_path: window.location.pathname });
//     `;
//     document.head.appendChild(script2);
//   };

//   // Wait until the entire page is loaded before fetching analytics
//   if (document.readyState === 'complete') {
//     loadAnalytics();
//   } else {
//     window.addEventListener('load', loadAnalytics);
//     return () => window.removeEventListener('load', loadAnalytics);
//   }

//   // Track pageviews on route change
//   const handleRouteChange = (url) => {
//     if (typeof window.gtag === "function") {
//       window.gtag("config", GA_TRACKING_ID, { page_path: url });
//     }
//   };

//   router.events.on("routeChangeComplete", handleRouteChange);
//   return () => {
//     router.events.off("routeChangeComplete", handleRouteChange);
//   };
// }, []);


useEffect(() => {
  if (typeof window === "undefined") return; // ← SSR guard

  const loadGTM = () => {
    if (document.getElementById("gtm-script")) return;

    // ← initialize dataLayer before script loads
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_TRACKING_ID, {
      send_page_view: false // ← prevent duplicate pageview on load
    });

    const script = document.createElement("script");
    script.id = "gtm-script";
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    script.async = true;
    document.head.appendChild(script);
  };

  const events = ["mousedown", "touchstart", "keydown", "scroll"];
  const handleInteraction = () => {
    loadGTM();
    events.forEach((e) => window.removeEventListener(e, handleInteraction));
  };
  events.forEach((e) =>
    window.addEventListener(e, handleInteraction, { passive: true })
  );

  const fallback = setTimeout(loadGTM, 5000);

  return () => {
    clearTimeout(fallback);
    events.forEach((e) => window.removeEventListener(e, handleInteraction));
  };
}, []);

// useEffect(() => {
//   // Load GA script
//   const script1 = document.createElement("script");
//   script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
//   script1.async = true;
//   document.head.appendChild(script1);

//   // Init GA config
//   const script2 = document.createElement("script");
//   script2.innerHTML = `
//     window.dataLayer = window.dataLayer || [];
//     function gtag(){dataLayer.push(arguments);}
//     gtag('js', new Date());
//     gtag('config', '${GA_TRACKING_ID}', {
//       page_path: window.location.pathname,
//     });
//   `;
//   document.head.appendChild(script2);

//   // Track pageviews on route change
//   const handleRouteChange = (url) => {
//     if (typeof window.gtag === "function") {
//       window.gtag("config", GA_TRACKING_ID, {
//         page_path: url,
//       });
//     }
//   };

//   router.events.on("routeChangeComplete", handleRouteChange);
//   return () => {
//     router.events.off("routeChangeComplete", handleRouteChange);
//   };
// }, []);
useEffect(() => {
  const initNomba = async () => {
    if (typeof window === "undefined") return;

    const { InitializeNombaCheckout } = await import(
      "react-nomba-checkout-sdk"
    );

    InitializeNombaCheckout();
  };

  initNomba();
}, []);



  return (
    <>
        <FreshChatWidget />
       <Provider store={store}>
       <AppWithIdleLogout>
        
      <ComponentWrapper Component={Component} pageProps={pageProps} />
     
      <NotificationContainer />

       </AppWithIdleLogout>
     
    </Provider>
    </>
   
  );
}

export default MyApp;

// export async function getServerSideProps(context) {
//   const { req } = context;
  

//   // Check for a token (e.g., in cookies)
//   const token = req.cookies.token;

//   if (!token) {
//     return {
//       redirect: {
//         destination: "/signup",
//         permanent: false,
//       },
//     };
//   }

//   return {
//     props: {}, // Pass additional data to your component if needed
//   };
// }



// A higher-order component to handle idle logout
const AppWithIdleLogout = ({ children }) => {
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);

  const handleLogout = () => {
    dispatch({ type: "LOGOUT" }); // Replace with your actual logout action
    Router.push("/signup"); // Redirect to login page
  };

  // Initialize idle logout with 60-minute timeout
  useIdleLogout(60, handleLogout);
 
 
  // If the token is null, redirect to login
  useEffect(() => {
    if (token ) {
      setTimeout(() => {
      
        if (token === null){
          setShowModal(true);

        }
       
        
      
      }, 5000);
    } 
  }, [token]);
  
  const handleCloseModal = () => {
    setShowModal(false);
  };
  

  return <>{children}
  
  
  </>;
};